import { v4 as uuid } from 'uuid';
import { Tag, Card } from 'antd';
import {
  getPriceText,
  formatDecimal,
} from '@zorba-shared/core/Services/textService';
import { AiFillCheckCircle } from '@react-icons/all-files/ai/AiFillCheckCircle';
import { AiFillCloseCircle } from '@react-icons/all-files/ai/AiFillCloseCircle';
import MatchingBuyersTable from '../MatchingBuyersTable';
import { MAPPED_PARAMS, MAPPED_TAX_ASSESSOR_PARAMS } from '../../constants';
import GenerateOffer from '../GenerateOffer';

export const MatchingBuyersTab = ({
  address,
  isCheckingBuyers,
  zillowData,
  taxAssessorData,
  inputObj,
  params,
  setParams,
  buyers,
  buyerFilteredList,
  buyersWithMatchingBuybox,
  isGeneratingOffer,
  maxOffer,
  selectedFilters,
}) => {
  const getPropValue = (obj) => {
    if (obj.type === 'price')
      return zillowData && zillowData[obj.prop]
        ? getPriceText(zillowData[obj.prop].toFixed(2))
        : 'Unknown';
    if (obj.prop === 'schoolRating')
      return zillowData && zillowData[obj.prop]
        ? formatDecimal(zillowData[obj.prop], 1)
        : 'Unknown';

    return zillowData && zillowData[obj.prop] != null
      ? zillowData[obj.prop]
      : 'Unknown';
  };

  const getTaxAssessorPropValue = (obj) => {
    if (obj.type === 'boolean') {
      return taxAssessorData && taxAssessorData[obj.prop] != null
        ? taxAssessorData[obj.prop].toString()
        : 'Unknown';
    }

    return taxAssessorData && taxAssessorData[obj.prop] != null
      ? taxAssessorData[obj.prop]
      : 'Unknown';
  };

  const getTitle = (title, data) =>
    data ? (
      <div style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
        <AiFillCheckCircle
          style={{ color: '#49e387', marginRight: 5, fontSize: 35 }}
        />
        <div>{title}</div>
      </div>
    ) : (
      <div style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
        <AiFillCloseCircle
          style={{ color: '#fc6d6d', marginRight: 5, fontSize: 35 }}
        />
        <div>{title}</div>
      </div>
    );

  return (
    <>
      {address && !isCheckingBuyers && (
        <Card
          title={getTitle('Zillow Data', zillowData)}
          className="buybox-checker-section-container tax-assessor-container"
        >
          {MAPPED_PARAMS.map((obj) => (
            <Tag className="buybox-checker-tag" key={obj.title}>
              <span className="tag-label">{obj.title}:</span>
              {getPropValue(obj)}
            </Tag>
          ))}
        </Card>
      )}

      {address && !isCheckingBuyers && (
        <Card
          title={getTitle('Tax Assessor Data', taxAssessorData)}
          className="buybox-checker-section-container tax-assessor-container"
        >
          {(taxAssessorData?.owners || []).map((owner) => (
            <Tag className="buybox-checker-tag" key={uuid()}>
              <span className="tag-label">Owner:</span>
              {owner}
            </Tag>
          ))}
          {taxAssessorData?.latestAvm && (
            <Tag className="buybox-checker-tag">
              <span className="tag-label">AVM:</span>
              {getPriceText(taxAssessorData.latestAvm)}
            </Tag>
          )}
          {MAPPED_TAX_ASSESSOR_PARAMS.map((obj) => (
            <Tag className="buybox-checker-tag" key={obj.title}>
              <span className="tag-label">{obj.title}:</span>
              {getTaxAssessorPropValue(obj)}
            </Tag>
          ))}
          {inputObj?.floodZone && (
            <Tag className="buybox-checker-tag">
              <span className="tag-label">Flood Zone:</span>
              {inputObj?.floodZone}
            </Tag>
          )}
        </Card>
      )}
      {address && !isCheckingBuyers && (
        <Card title="Generate Offer">
          <GenerateOffer
            params={params}
            zillowData={zillowData}
            setParams={setParams}
            buyers={buyers}
            address={address}
            onSubmitButtonText="Generate offer"
          />
        </Card>
      )}
      <div className="matching-buyer-table-container">
        <MatchingBuyersTable
          address={address}
          data={buyerFilteredList}
          buyersWithMatchingBuybox={buyersWithMatchingBuybox}
          isLoading={isCheckingBuyers || isGeneratingOffer}
          maxOffer={maxOffer}
          isShowMatchingCount={selectedFilters?.buyers?.length}
        />
      </div>
    </>
  );
};
